// @ts-strict-ignore
import * as React from 'react';

import styles from '../index.module.styl';

export const Content = ({children}) => {
  return <div className={styles.content}>{children}</div>;
};
